import { c as _c } from "react/compiler-runtime";
import { DowngradeMutationErrorResponse, TRegistrationSubmit } from '@util/registration/BasicFormModel';
import { toBasicRegistrationData } from '@data/api/mappers/workflowData/toBasicRegistrationData';
import { RequestInfo, requester } from '@data/api/requester';
import { UseMutationOptions, UseMutationResult, useMutation } from '@tanstack/react-query';
type PostBasicRegistrationArgs = TRegistrationSubmit;

/** BE route: registration_api_basic_step_post */
export const postBasicRegistrationRequest = (data: PostBasicRegistrationArgs): RequestInfo<TBasicStepWorkflowData> => ({
  method: 'POST',
  url: '/registration/basic',
  body: data,
  responseMapper: toBasicRegistrationData,
  // `params` will pick up the query string from the URL and
  // forward the data to the backend.
  // it does NOT support the array syntax for querystrings
  // example: "?param[]=a&param[]=b" will not work as expected.
  params: Object.fromEntries(new URLSearchParams(window.location.search).entries())
});
const mutationFn = (requestArgs: PostBasicRegistrationArgs) => requester(postBasicRegistrationRequest(requestArgs));
type Data = TBasicStepWorkflowData;
type Options = UseMutationOptions<Data, ApiError<DowngradeMutationErrorResponse>, PostBasicRegistrationArgs>;
export const useBasicRegistrationMutation = options => {
  const $ = _c(2);
  let t0;
  if ($[0] !== options) {
    t0 = {
      ...options,
      mutationFn
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};